export type Translations = Record<
  string,
  { message: string; crowdinContext?: string }
>;

export const locales = [
  'da',
  'de',
  'en',
  'es',
  'fi',
  'fr',
  'it',
  'is-IS',
  'ko',
  'nb',
  'nl',
  'pl',
  'pt-BR',
  'pt-PT',
  'sv',
  'th',
  'tr',
  'ar',
  'zh-TW',
  'zh-CN',
  'he',
  'ja',
  'cy',
] as const;

export type Locale = typeof locales[number];
